var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{staticClass:"yi-dialog-wrapper",class:{ 'bg-white': _vm.bgWhite },attrs:{"visible":_vm.visible,"title":_vm.dialogTitle,"append-to-body":"","width":_vm.dialogSize,"show-close":false}},[_c('div',{staticClass:"dialog-wrapper-body"},[_vm._t("default")],2),_c('template',{slot:"footer"},[_vm._t("footer")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }